export default __webpack_public_path__ + "static/media/March2019.4f003b25.png";